import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import NoDataFoundMex from "../ViewComponents/NoDataFound";
import FormatDateTime from "../../Functions/FormatDate";
import { BiCopy } from "react-icons/bi";

const TableAccess = ({ data, handleDeleteClick, handleEditClick }) => {
  const { t } = useLanguage();
  const [sortedData, setSortedData] = useState(data || []);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [copiedId, setCopiedId] = useState(null);
  const no_data_mex = t.access.table.no_data

  useEffect(() => {
    setSortedData(data);
  }, [data]);

  const headers = sortedData.length > 0
    ? Object.keys(sortedData[0]).filter(header => !["access_name", "access_surname", "access_password", "project_id"].includes(header))
    : [];

  if (!headers.includes("access_user")) {
    headers.push("access_user");
  }
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sorted = [...sortedData].sort((a, b) => {
      const aValue = a[key] || "";
      const bValue = b[key] || "";

      return aValue < bValue ? (direction === "asc" ? -1 : 1) : aValue > bValue ? (direction === "asc" ? 1 : -1) : 0;
    });

    setSortedData(sorted);
    setSortConfig({ key, direction });
  };

  const handleIdClick = (id) => {
    navigator.clipboard.writeText(id).then(() => {
      setCopiedId(id);
      setTimeout(() => {
        setCopiedId(null);
      }, 3000);
    });
  };


  if (sortedData.length === 0) {
    return <NoDataFoundMex message={no_data_mex} />;
  }

  return (
    <div className="table-responsive fade-in">
      <table className="table">
        <thead>
          <tr>
            <th style={{ width: "40px" }}></th>
            {headers.map((header) => (
              <th
                key={header}
                onClick={() => handleSort(header)}
                style={{ cursor: "pointer" }}
                aria-sort={sortConfig.key === header ? (sortConfig.direction === "asc" ? "ascending" : "descending") : "none"}
                className={sortConfig.key === header ? "active-sort" : ""}
              >
                {t.access.table[header]}
                {sortConfig.key === header ? (
                  sortConfig.direction === "asc" ? (
                    <i className="fa-solid fa-arrow-up"></i>
                  ) : (
                    <i className="fa-solid fa-arrow-down"></i>
                  )
                ) : null}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedData.map((row, rowIndex) => (
            <tr key={rowIndex} >
              <td className={`${row._id == "default" ? "default_row" : ""}`}>
                <Dropdown>
                  <div className="property_btn_action_toggle">
                    <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                      <i className="fa-solid fa-ellipsis-vertical"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="custom-dropdown-menu">
                      {/* <Dropdown.Item className="drop_down_item" onClick={() => handleEditClick(row._id)}>
                        <i className="fa-solid fa-pencil"></i> {t.edit}
                      </Dropdown.Item> */}
                      {row._id != "default" && (
                        <Dropdown.Item className="drop_down_item delete" onClick={() => handleDeleteClick(row.access_email, "deleted")}>
                          <i className="fa-solid fa-trash"></i> {t.delete}
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </div>
                </Dropdown>
              </td>
              {headers.map((header) => {
                let cellData = "";

                if (header === "access_user") {
                  cellData = `${row.access_name || ""} ${row.access_surname || ""}`.trim();
                } else {
                  cellData = row[header];
                }

                return (
                  <td key={`${rowIndex}-${header}`} onClick={header === "_id" ? () => handleIdClick(cellData) : undefined} className={`${row._id == "default" ? "default_row" : ""}`}>
                    <div className={copiedId === row._id ? "copied_item" : ""} title={cellData}>
                      {header === "_id" ? (
                        <div className="id_cell">
                          <p>{cellData}</p>
                          <BiCopy style={{ marginLeft: "8px" }} />
                        </div>
                      ) : header == "timestamp" ? (
                        (FormatDateTime(cellData))
                      ) : header == "cluster" || header == "database" ? (
                        <div className={["write", "fullAccess"].includes(cellData) ? "allow_cells" : "neg_cells"}>
                          {t.access.table[cellData]}
                        </div>
                      ) : (
                        cellData
                      )}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableAccess;
